exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hover-7-wrapper[data-v-6a65d367]{width:330px;padding-bottom:10px}", ""]);

// exports
